import React from 'react'
import { Popup } from 'semantic-ui-react'

import { LKIcon } from 'loankeeper-common/components'
import { translateLKMessage } from './translator'

const formatRate = (rateStr: string | number) => {
  const num = Number(rateStr)
  return !isNaN(num) ? num.toFixed(4) : 1 // eslint-disable-line no-restricted-globals
}

const target = (
  <div className="item">
    <LKIcon alias="alert" size={20} style={{ position: 'relative', top: '4px' }} />
  </div>
)

const mapCurrentyRateItem =
  (localCCY: string) =>
  ({ currency, rate }: { currency: string; rate: number }) => {
    if (!rate || rate < 0) {
      return <Popup content={translateLKMessage('ERR_MISSING_ISORATE')} trigger={target} position="top center" />
    }

    return `1 ${currency} = ${formatRate(rate)} ${localCCY}`
  }

const OfficialRates = ({
  localCCY,
  items,
}: {
  localCCY: string
  items: Array<{ rate: number; currency: string }>
}): any => {
  if (items.every((i) => i.rate === 0 || i.rate < 0)) {
    return translateLKMessage('ERR_MISSING_ISORATE')
  }

  return items.map(mapCurrentyRateItem(localCCY)).map((item, index) => (
    <React.Fragment key={index}>
      {item}
      {index !== items.length - 1 && ' | '}
    </React.Fragment>
  ))
}

export default OfficialRates
